import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { clearEmptyProperties } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { isEqual } from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';

@Component({
  selector: 'filter-locations',
  templateUrl: './filter-locations.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FilterLocationsComponent implements OnInit, OnDestroy {
  private subscriptions = new Subject<void>();
  private defaultWhere = { archived: false };

  public filtersForm: FormGroup;
  public filtered = false;
  public filtersChanged = new BehaviorSubject<any>(this.defaultWhere);

  constructor(
    private formBuilder: FormBuilder,
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({english, portuguese, spanish});
  }

  ngOnDestroy(): void {
    this.subscriptions.next();
    this.subscriptions.complete();
  }

  ngOnInit(): void {
    this.filtersForm = this.formBuilder.group({
      name_contains: null,
      locationGroupId_in: null,
      companyId_in: null,
      archived: false,
      documentNumber_contains: null
    });

    this.filtersForm.valueChanges
      .pipe(takeUntil(this.subscriptions))
      .subscribe((filterValue) => {
        const where = clearEmptyProperties(filterValue);
        this.filtersChanged.next(where);
        this.filtered = !isEqual(where, this.defaultWhere);
      });

  }

  public clearFilters(): void {
    this.filtersForm.patchValue({
      name_contains: null,
      locationGroupId_in: null,
      companyId_in: null,
      archived: false,
      documentNumber_contains: null
    });
  }

  getPropertyValue(value, array, property): any {
    const item = array.find((a) => a.id === value);
    return item[property];
  }
}
